export enum SurveyStep {
  Answer = 'answer',
  Email = 'email',
  Acknowledge = 'acknowledge',
  Prediction = 'prediction',
  Rectify = 'rectify',
  Probability = 'probability',
  Forecasting = 'forecasting',
  ResultsIntermediate = 'results-intermediate',
  Results = 'results',
  Sandbox = 'sandbox',
}
